import type {Mapper} from 'framework';
import type {BodyMetric} from '../../domain/body-metric';
import type {BodyMetricDto} from '../dto/body-measurements.dto';

export class BodyMetricDtoToBodyMetricMapper implements Mapper<BodyMetricDto, BodyMetric> {
  transform(dto: BodyMetricDto): BodyMetric {
    return {
      id: dto.id,
      kind: dto.kind,
      builtInKey: dto.builtInKey,
      name: dto.name,
      enabled: dto.enabled,
      sortOrder: dto.sortOrder,
    };
  }
}
